import { render, staticRenderFns } from "./SurveyThemePicker.vue?vue&type=template&id=2a3008f8&"
import script from "./SurveyThemePicker.vue?vue&type=script&lang=js&"
export * from "./SurveyThemePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports